import { NavigationMenu as BaseNavigationMenu } from "@base-ui-components/react/navigation-menu";
import { navigationMenuListClasses } from "./NavigationMenu.style";

type NavigationMenuListProps = BaseNavigationMenu.List.Props;

const NavigationMenuList = (props: NavigationMenuListProps) => {
  const { children, className, role = "menu", ...rest } = props;
  const resolvedClassName =
    typeof className === "function" ? className({ open: false }) : className;
  return (
    <BaseNavigationMenu.List
      className={navigationMenuListClasses({ class: resolvedClassName })}
      role={role}
      {...rest}
    >
      {children}
    </BaseNavigationMenu.List>
  );
};

export default NavigationMenuList;
